
import { requester } from "App";
import { mobileNoFormat, passwordFormat, textFormat, userNameFormat } from "InitialData/regExp";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import InputImage from "components/inputs/image/InputImage";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { validateInputs } from "shared/utils/Utils";

function AdminCategoryCreate() {
    const inputs = useRef([]);
    const { t } = useTranslation();
    const [category, setCategory] = useState();
    const id = 'root';
    const dispatch = useDispatch();


    const onClick = () => {
        
        let data = { storeId: id, categoryName: "", categoryImage: "" }
        validateInputs(inputs.current).then((result) => {
            if (result.isValid) {
                data.categoryName = inputs.current[0].getValue();
                data.categoryImage = inputs.current[1].getValue();
        
                requester.createCategory(data, (result) => {
        
                })
            } else {
                toast.error(t("pleaseCheck"), {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });


    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none"
    }

    return (
        <Container>
            <Container maxWidth={1200}>
                <Center width={"100%"} textAlign={"left"}>
                    <P size={40} font={"gmarketSansBold"} color={"black"}>카테고리 생성</P>
                </Center>
                <VerticalFlex gap={20}>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>카테고리명 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"카테고리명"} regExp={[textFormat]} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex gap={30}>
                            <FlexChild width={"20%"} >
                                <P>카테고리 이미지 : </P>
                            </FlexChild>
                            <FlexChild>
                                <InputImage ref={el => (inputs.current[1] = el)} name={"상품 라벨"} path={"category/"} labelWidth={0} cropWidth={150} cropHeight={150} value={category && category.image ? category.image : ""} maxSizeMb={1} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <CustomButton text={"카테고리등록"} style={btnStyle} onClick={onClick} />
                    </FlexChild>
                </VerticalFlex>


            </Container>
        </Container >
    );
}

export default AdminCategoryCreate;